export function setCookie(name: string, value: any, options?: Record<string, any> & { daysToLive?: number }) {
  let cookie = `${name}=${encodeURIComponent(value)}`;

  if (typeof options === 'object') {
    if (options.daysToLive) {
      const maxAge = options.daysToLive * 24 * 60 * 60;
      cookie += `; max-age=${maxAge}`;
    }

    Object.entries(options).forEach(([option, optionValue]) => {
      if (option !== 'daysToLive') {
        cookie += `; ${option}=${optionValue}`;
      }
    });
  }

  try {
    document.cookie = cookie;
  } catch (error) {
    console.error('Failed to set cookie:', error);
  }
}

export function getCookieByName(cookieName: string) {
  const cookie: { [key: string]: string } = {};
  document.cookie.split(';').forEach((el) => {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}
